import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstance2k9zaro5cmj1m as Companion_getInstance } from '../models/ScreenTransitions.mjs';
import { get_overlayFrameoxw7w6vy469q as get_overlayFrame } from './l2/AppNavV2.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_animationsEnabled25ujr8oia8gbs as get_animationsEnabled,
  set_animationsEnabled1ac1lbh50s602 as set_animationsEnabled,
} from './RView.js.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  animateIn1nlg63kph14n6 as animateIn,
  animateOut3n4hfswesreuc as animateOut,
} from './animations.js.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_0 } from '../ViewWrapper.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function overlayWriter(_this__u8e3s4, modal, transition, body) {
  modal = modal === VOID ? true : modal;
  transition = transition === VOID ? Companion_getInstance().mbb_1 : transition;
  var willRemove = {_v: null};
  var tmp0_elvis_lhs = get_overlayFrame(_this__u8e3s4);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  // Inline function 'kotlin.with' call
  var $this$with = tmp;
  // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
  var tmp_0 = $this$with.tb5_1.vb3_1;
  var tmp0_safe_receiver = tmp_0 instanceof HTMLElement ? tmp_0 : null;
  var tmp_1;
  if (tmp0_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
    var this_0 = tmp0_safe_receiver;
    var animate = get_animationsEnabled();
    try {
      if (animate) {
        set_animationsEnabled(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_2 = this_0.__suppressMutationObserverClass;
        var tmp0_elvis_lhs_0 = tmp_2 instanceof ArrayList() ? tmp_2 : null;
        var tmp_3;
        if (tmp0_elvis_lhs_0 == null) {
          // Inline function 'kotlin.run' call
          var n = ArrayList().w();
          // Inline function 'kotlin.js.asDynamic' call
          this_0.__suppressMutationObserverClass = n;
          tmp_3 = n;
        } else {
          tmp_3 = tmp0_elvis_lhs_0;
        }
        var e = tmp_3;
        this_0.classList.add('notransition');
        var tmp1_elvis_lhs = this_0.getAttribute('class');
        e.v(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
      }
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
      var prev = $this$with.bbb_1;
      var tmp_4 = $this$with;
      tmp_4.bbb_1 = (_this__u8e3s4) => {
        var tmp0_safe_receiver = prev;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver(_this__u8e3s4);
        animateIn(_this__u8e3s4, transition.pbb_1);
        willRemove._v = _this__u8e3s4;
        return Unit_instance;
      };
      Companion_getInstance_0();
      body($this$with, () => {
        var tmp0_safe_receiver = willRemove._v;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it = tmp0_safe_receiver;
          animateOut(it, transition.qbb_1, () => {
            $this$with.sba(it);
            return Unit_instance;
          });
        }
        return Unit_instance;
      });
    }finally {
      if (animate) {
        var tmp_5 = window;
        tmp_5.setTimeout(() => {
          // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
          var this_1 = this_0;
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = this_1.__suppressMutationObserverClass;
          var tmp0_elvis_lhs = tmp instanceof ArrayList() ? tmp : null;
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.run' call
            var n = ArrayList().w();
            // Inline function 'kotlin.js.asDynamic' call
            this_1.__suppressMutationObserverClass = n;
            tmp_0 = n;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var e = tmp_0;
          this_0.classList.remove('notransition');
          var tmp1_elvis_lhs = this_1.getAttribute('class');
          e.v(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
          return Unit_instance;
        }, 100);
        set_animationsEnabled(true);
      }
    }
    tmp_1 = Unit_instance;
  }
  if (tmp_1 == null) {
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
    var prev_0 = $this$with.bbb_1;
    var tmp_6 = $this$with;
    tmp_6.bbb_1 = (_this__u8e3s4) => {
      var tmp0_safe_receiver = prev_0;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver(_this__u8e3s4);
      animateIn(_this__u8e3s4, transition.pbb_1);
      willRemove._v = _this__u8e3s4;
      return Unit_instance;
    };
    Companion_getInstance_0();
    body($this$with, () => {
      var tmp0_safe_receiver = willRemove._v;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var it = tmp0_safe_receiver;
        animateOut(it, transition.qbb_1, () => {
          $this$with.sba(it);
          return Unit_instance;
        });
      }
      return Unit_instance;
    });
  }
}
//region block: exports
export {
  overlayWriter as overlayWriter1bxnhxr8o82ue,
};
//endregion

//# sourceMappingURL=ViewContextExtensions.commonHtml.mjs.map
